<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.36364 6.54545H5.74008C7.49514 4.53761 9.41747 3.81818 12 3.81818C16.5187 3.81818 20.1818 7.48131 20.1818 12C20.1818 16.5187 16.5187 20.1818 12 20.1818C7.48131 20.1818 3.81818 16.5187 3.81818 12H2C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C9.07875 2 6.76098 2.82778 4.72727 4.96041V2.9011H2.90909V8.36364H8.36364V6.54545ZM16.5455 11.0909H12.9091V6.54545H11.0909V12.9091H16.5455V11.0909Z"
  />
</template>
